import { render, staticRenderFns } from "./MobileService.vue?vue&type=template&id=ccf11820&scoped=true&"
import script from "./MobileService.vue?vue&type=script&lang=js&"
export * from "./MobileService.vue?vue&type=script&lang=js&"
import style0 from "./MobileService.vue?vue&type=style&index=0&id=ccf11820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf11820",
  null
  
)

export default component.exports